<template>
    <div>        
        <v-flex>        
            <v-text-field                 
                :append-icon="selectedIcon"
                @click:clear="selectCleared"
                @click="showModal"             
                v-model="iconText"          
                :value="value"
                label="Icon"       
                clearable                
            ></v-text-field>        
        </v-flex>
        <v-layout row justify-center>
            <v-dialog v-model="showPicker" scrollable max-width="300px">
                <v-card>
                    <v-card-title>
                        Selecteer een icoontje
                        <v-text-field  
                            v-model="filterText"                                                           
                            label="Filter op icon (Engelse namen)"                       
                        ></v-text-field>                           
                    </v-card-title>
                    <v-card-text style="height: 300px;">
                        <v-layout row wrap>
                        <v-flex v-for="icon in filteredIcons" :key="icon.name" d-flex>
                           <template v-if="icon.type == 'n'">
                                <v-flex class='icon-tray' px-2 py-2 mx-1 my-1 @click="selectIcon(icon.name, 'fas')" text-xs-center>
                                    <i :class="`fas fa-${icon.name} fa-2x primary--text text--lighten-2`"></i>                                
                                </v-flex>                    
                                <v-flex class='icon-tray' px-2 py-2 mx-1 my-1 @click="selectIcon(icon.name, 'far')" text-xs-center>
                                    <i :class="`far fa-${icon.name} fa-2x primary--text text--lighten-2`"></i>                                
                                </v-flex>                    
                                <v-flex class='icon-tray' px-2 py-2 mx-1 my-1 @click="selectIcon(icon.name, 'fal')" text-xs-center>
                                    <i :class="`fal fa-${icon.name} fa-2x primary--text text--lighten-2`"></i>                                
                                </v-flex>  
                            </template>     
                            <template v-if="icon.type == 'b'">
                                <v-flex class='icon-tray' px-2 py-2 mx-1 my-1 @click="selectIcon(icon.name, 'fab')" text-xs-center>
                                    <i :class="`fab fa-${icon.name} fa-2x primary--text text--lighten-2`"></i>                                
                                </v-flex>                                  
                            </template>                                                                      
                        </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="showPicker= false">Sluiten</v-btn>
                    </v-card-actions>  
                </v-card>          
            </v-dialog>   
        </v-layout>
    </div>
</template>

<script>
import _ from 'lodash';
import DD_ICONS from '../../assets/icons';
    export default {
        data() {
            return {
                showPicker:false,
                iconText:"",
                filterText:""
            }
        },        
        computed: {
            filteredIcons(){
                if(this.filterText.length == 0){
                    return this.iconList
                }
                let vm = this;
                return _.filter(this.iconList, (item)=>{ return item.name.includes(vm.filterText) })            
            },
            selectedIcon() {
                if(this.iconText){
                    return this.iconText+" fa-1x primary--text text--lighten-2";
                }
                return "";
            },
            iconList(){
                return DD_ICONS;
            }
        },
        methods: {
            selectIcon(name, type) {
                this.iconText = this.buildClassName(name,type);                
                this.showPicker=false;
                this.$emit('input',  this.iconText);
            },
            buildClassName(name,type){
                return `${type} fa-${name}`; 
            },
            showModal(){
                this.showPicker=!this.showPicker                
                this.filterText=""
            },
            onFocus(){
                this.showModal()
            },
            selectCleared(){
                this.$emit('input', "")
            }
        },
        props:['value'],
        watch: {
            'value': {
                handler:function(newValue){                    
                    this.iconText = newValue;                    
                },
                deep:true
            }
        },
        created(){            
            this.iconText = this.value
        }

    }
</script>

<style scoped>
    .icon-tray{
        width: 50px;
        height: 50px;
        border: 1px solid lightgray;
    }
    .icon-tray:hover{
        background-color:lightgray;
        cursor:pointer;
    }
</style>